import { OccupancyEnum } from "@ryde/shared";
import { lightBlueMui, orangeMui, redMui, tealMui } from "@ryde/theme";

export const getColorByOccupancy = (occupancy: OccupancyEnum): string => {
  switch (occupancy) {
    case OccupancyEnum.Low:
      return redMui.A400;
    case OccupancyEnum.High:
      return tealMui.A700;
    case OccupancyEnum.Medium:
      return orangeMui.A400;

    default:
      return lightBlueMui._700;
  }
};
